export class Cartao {
  public descricao: string;
  public nome: string;
  public possui_validade: boolean = false;
  public quantidade_de_pontos: number;
  public data_fim_validade: string;
  public id_cartao: number;
  public id: number;
  public padrao: boolean = false;
  constructor() {

  }
}
